(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["provena-quick-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest?.('.pqo') || document.querySelector('.pqo');
    if (!root) return;
    const bar = root.querySelector('.pqo__bar');
    const summary = root.querySelector('[data-pqo-summary]');
    const addBtn = root.querySelector('[data-pqo-add]');
    const clearBtn = root.querySelector('[data-pqo-clear]');
    const errEl = root.querySelector('[data-pqo-error]');
    if (!bar) return; // stato "locked": niente da fare

    const inputs = () => Array.from(root.querySelectorAll('.pqo__qty'));
    const money = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');

    const refresh = () => {
      let cases = 0;
      let total = 0;
      for (const i of inputs()) {
        const q = Math.max(0, parseInt(i.value, 10) || 0);
        i.classList.toggle('has-qty', q > 0);
        cases += q;
        total += q * (parseInt(i.dataset.price, 10) || 0);
      }
      bar.hidden = cases === 0;
      if (summary) summary.textContent = cases + (cases === 1 ? (summary.dataset.lOne || ' case — ') : (summary.dataset.lMany || ' cases — ')) + money(total);
    };

    root.addEventListener('input', (e) => {
      if (e.target.classList.contains('pqo__qty')) refresh();
    });
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.pqo__step');
      if (!btn) return;
      const input = btn.parentElement.querySelector('.pqo__qty');
      const next = Math.min(999, Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.step, 10)));
      input.value = next;
      refresh();
    });
    clearBtn?.addEventListener('click', () => {
      for (const i of inputs()) i.value = 0;
      refresh();
    });
    addBtn?.addEventListener('click', async () => {
      const items = inputs()
        .map((i) => ({ id: parseInt(i.dataset.variantId, 10), quantity: Math.max(0, parseInt(i.value, 10) || 0) }))
        .filter((x) => x.quantity > 0);
      if (!items.length) return;
      addBtn.disabled = true;
      errEl.hidden = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || errEl.dataset.lErr || 'Could not add to cart.');
        }
        window.location.href = '/cart';
      } catch (err) {
        errEl.textContent = err.message;
        errEl.hidden = false;
        addBtn.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
